import React from 'react'
import { Row, Col, CloseButton, Alert, Spinner } from '@deere/ux.uxframe-react'
import { AssignmentListItem } from "../components/AssignmentListItem";
import { Container } from "@deere/ux.uxframe-react";
import { DOWNLOAD_ERROR, NO_INFORMATION, NO_SUPPLIERS } from '../utils/surveyLiterals';
import { LeftSearchMenu } from '../search/LeftSearchMenu'
import { useSelector } from 'react-redux'
import { ListPagination } from '../components/ListPagination';

export const SupplierView = ({ userInfo, showModal, hideModal, authState, abortControllerRef }) => {
    const assignments = useSelector(state => state.campaign.assignments)
    const loading = useSelector(state => state.campaign.loading)
    return (
        <Container fluid>
            <div style={{ margin: "10px" }}>
                <Row>
                    <Col className="col-md-24">
                        <h2>Search</h2>
                    </Col>
                </Row>
            </div>
            <Row>
                <div className='col-md-7'>
                    <LeftSearchMenu userInfo={userInfo} authState={authState} isEmployee={false} abortControllerRef={abortControllerRef} />
                </div>
                <div className='col-md-17'>
                    {userInfo && (!userInfo.suppliers || userInfo.suppliers.length === 0) ?
                        <Alert accessibilityLabel={'Info :'} variant={'info'} aria-atomic="true">
                            <h5 className="uxf-alert-title">{NO_SUPPLIERS}{userInfo.userID}</h5>
                        </Alert>
                        : ''
                    }
                    {assignments && assignments.length === 0 ?
                        <Alert accessibilityLabel={'Info :'} variant={'info'} aria-atomic="true">
                            <h5 className="uxf-alert-title">{NO_INFORMATION}</h5>
                        </Alert>
                        : ''
                    }
                    {showModal &&
                        <Alert accessibilityLabel={'Danger :'} variant={'danger'} aria-atomic="true">
                            <h5 className="uxf-alert-title">{DOWNLOAD_ERROR}  <CloseButton onClick={hideModal} /></h5>
                        </Alert>
                    }
                    {loading ? <Spinner style={{
                        margin: 'auto',
                    }} animation="border" role="status">
                        <span className="visually-hidden"></span>
                    </Spinner> : <ListPagination list={assignments} authState={authState} component={AssignmentListItem} />}
                </div>
            </Row>
        </Container>
    )
}